import { Chip } from '@mui/material';
import type { LabourItemStatus } from '../../../api/sitesApi';

interface LabourItemStatusBadgeProps {
  status: LabourItemStatus;
}

const statusConfig: Record<
  LabourItemStatus,
  { label: string; color: 'default' | 'primary' | 'success' }
> = {
  NotStarted: { label: 'Not Started', color: 'default' },
  InProgress: { label: 'In Progress', color: 'primary' },
  Complete: { label: 'Complete', color: 'success' },
};

export function LabourItemStatusBadge({ status }: LabourItemStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
}
